<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
</div>
<div class="date-filter" [formGroup]="invoiceListForm">

  <div class="grid">
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="startDate">Start Date</label>
        <div class="custom-select">
          <p-calendar #calendarTopStartDateRef dateFormat="M dd, yy" [inputStyle]="{'width':'95%'}"
          inputId="startDateInput"
          [appEnterKeyListener]="'start'"
          (keydown.enter)="searchByFilter()"
            placeholder="Select Date" formControlName="startDate"></p-calendar><img [calendarOpener]="calendarTopStartDateRef"
            src="assets/images/date-calender.png" alt="calender" />
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="endDate">End Date</label>
        <div class="custom-select">
          <p-calendar #calendarTopEndDateRef dateFormat="M dd, yy" [inputStyle]="{'width':'95%'}"
          inputId="endDateInput"
          [appEnterKeyListener]="'end'"
          (keydown.enter)="searchByFilter()"
            placeholder="Select Date" formControlName="endDate"></p-calendar><img [calendarOpener]="calendarTopEndDateRef"
            src="assets/images/date-calender.png" alt="calender"/>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="paymentStatus">Payment Status</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <p-dropdown [options]="selectStatus" (onChange)="onChangePaymentStatus($event)" placeholder="Select Status" formControlName="paymentStatus"
             optionLabel="name" optionValue="id" optionValue="value"></p-dropdown>
             <img src="../../../../assets/images/fill-dropdown.svg" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="invoiceNumber">Invoice Number</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input id="invoiceNumber" type="text" pInputText placeholder="Enter Invoice Number" formControlName="invoiceNumber" (keydown.enter)="searchByFilter()" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-1">
      <div class="date-outer-btn">
        <div class="edit-outer">
          <p-button styleClass="p-button search-button" label="Search" (onClick)="searchByFilter()"></p-button>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-1">
      <div class="date-outer-btn">
        <div class="edit-outer reset-btn">
          <p-button styleClass="p-button  p-button-outlined" label="Reset" (onClick)="resetFilter()"></p-button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="driver-list-outer">
  <div class="list-heading">
    <h4>Custom Invoices</h4>
    <div class="page-list filter-parking">
      <div class="records-outer">
     <span>Show</span>
     <div class="records-inner"> <p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event)" placeholder="10"
          optionLabel="name" optionValue="value" [(ngModel)]="SearchItemPerPageBy"></p-dropdown><img
          src="assets/images/fill-dropdown.svg" alt=""/></div>
        <span>Records</span>
      </div>
    </div>
  </div>
  <div class="card parking-list fullwidth-table-scroll common-heighttd booking-outer" [class.parking-list]="invoiceList?.length>0">
    <p-table id="tbl-top" [value]="invoiceList">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" class="parking-lots">Parking Lot</th>
          <th scope="col">Invoice Number</th>
          <th scope="col">Arrival Date & Time</th>
          <th scope="col">Departure Date & Time</th>
          <th scope="col">Time Zone</th>
          <th scope="col">Items</th>
          <th scope="col">Invoice Date</th>
          <th scope="col">Created Date</th>
          <th scope="col">Total Amount ($)</th>
          <th scope="col">Payment Status</th>
          <th scope="col">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr class="border12">
          <td>
            <div class="custom-name custom-no-pointer">
              <div class="custom-name custom-no-pointer">
                  <div class="img-inner custom-no-pointer">
                      <img class="circle-img custom-no-pointer"
                          [src]="(rowData.companyLogo)?rowData.companyLogo:dummy" alt="Company logo"/>
                  </div>
                  <div class="custom-text">
                      <h5>{{rowData.parkingLotName}}</h5>
                      <p>{{rowData.address}}</p>
                  </div>
              </div>
           </div>
          </td>
          <td>{{rowData.invoiceNumber}}</td>
          <td>{{rowData.arrivalDate || '-'}}</td>
          <td>{{rowData.departureDate || '-'}}</td>
          <td>{{rowData?.timeZone ? getTimeZoneAbbreviation(rowData?.timeZone) : '-'}}</td>
          <td>{{rowData.items}}</td>
          <td>{{rowData.billingDate.split('|')[0].trim()}}</td>
          <td>{{rowData.dateCreated}}</td>
          <td>{{rowData.totalAmount}}</td>
          <td class="custom-text">
            <div class="big-parking"><p class="common-payment-status"
              [ngClass]="rowData.paymentStatus | invoicePaymentStatus">{{rowData.status}}
              <span *ngIf="rowData?.paymentFailureError && rowData.paymentStatus === invoicePaymentStatus.PaymentFailed"><em class="pi pi-info-circle" [pTooltip]="rowData?.paymentFailureError"
                tooltipPosition="top"></em></span>
            </p></div>
            </td>
          <td>
            <div class="export-btn">
              <img (click)="activeItem = rowData;showData(rowData);menu.toggle($event)"
                src="assets/images/dashboard-dot.svg" alt="" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-border">
          <td class="no-record" colspan="11">
            No Record Found
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="card flex justify-content-end custom-pagination1" *ngIf="invoiceList?.length >0">
      <p-paginator [first]="currentSkip" [rows]="itemsPerPage" [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"></p-paginator>
    </div>
  </div>
</div>
<div class="custom-export">
  <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>
